import { put, call, takeLatest } from 'redux-saga/effects';
import * as api from './Api';
import { actions } from './Reducer';
import {
  setMySupplierPublicInquiryIsLoading,
  // getSupplierPublicInquirySuccessAction,
  getMySupplierPublicInquirySuccessAction,
  getMySupplierPublicInquiriesSuccessAction,
  getMyPublicSupplierProposalsSuccessAction,
  addMyPublicSupplierProposalSuccessActon,
  editMyPublicSupplierProposalSuccessAction,
  getMyPublicSupplierProposalSuccessAction,
  deleteMyPublicSupplierProposalSuccessAction,
  setMySupplierPublicInquiriesCountAction,
  filterMySupplierPublicInquiriesSuccessAction
} from './Actions';

import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../../notifications/Actions';

import { push } from 'react-router-redux';

const body = {
  offset: 0,
  size: 10,
  searchTerm: '',
  filterBy: [{ moderated: false }], // for testing only value === true
  sort: 'createdAt',
  dir: 'asc',
};

function* getMySupplierPublicInquiries({ payload }) {
  const defBody = {
    ...body,
    ...payload,
  };
  try {
    yield put(setMySupplierPublicInquiryIsLoading(true));
    const response = yield call(api.getMySupplierPublicInquiries, defBody);
    const { data } = response;
    const { content, count } = data;
    console.log(content);
    yield put(getMySupplierPublicInquiriesSuccessAction(content));
    yield put(setMySupplierPublicInquiriesCountAction(count))
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPublicInquiryIsLoading(false));
  }
}


function* filterMySupplierPublicInquiries({ payload }) {
  const defBody = {
    ...body,
    ...payload,
  };
  try {
    yield put(setMySupplierPublicInquiryIsLoading(true));
    const response = yield call(api.getMySupplierPublicInquiries, defBody);
    const { data } = response;
    const { content, count } = data;
    console.log(content);
    yield put(filterMySupplierPublicInquiriesSuccessAction(content));
    // yield put(setMySupplierPublicInquiriesCountAction(count))
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPublicInquiryIsLoading(false));
  }
}



function* getSupplierPublicInquiry({ payload }) {
  const inquireyId = payload;
  const body = {
    inquiryID: inquireyId,
  };

  try {
    yield put(setMySupplierPublicInquiryIsLoading(true));
    const response = yield call(api.getMySupplierPublicInquiry, body);
    const { data } = response;

    console.log(data);
    yield put(getMySupplierPublicInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Get Public Inquiry'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPublicInquiryIsLoading(false));
  }
}

function* getSupplierPublicProposals({ payload }) {
  const defBody = {
    ...body,
    ...payload,
  };
  try {
    yield put(setMySupplierPublicInquiryIsLoading(true));
    const response = yield call(api.getMySupplierPublicInquiries, defBody);
    const { data } = response;
    const { content, count } = data;
    console.log(data)
    yield put(getMyPublicSupplierProposalsSuccessAction(content));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPublicInquiryIsLoading(false));
  }
}

function* getSupplierPublicProposal({ payload }) {
  const inquireyId = payload;
  const inquireyBody = {
    inquiryID: inquireyId,
  };

  try {
    yield put(setMySupplierPublicInquiryIsLoading(true));
    const response = yield call(api.getMySupplierPublicInquiry, inquireyBody)
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPublicInquiryIsLoading(false));
  }
}

function* addSupplierPublicProposal({ payload , trusted}) {
  try {
    yield put(setMySupplierPublicInquiryIsLoading(true));
    if (trusted) {
    const response = yield call(api.addSupplierPublicProposal, payload);
    const { data } = response;
    yield put(addMyPublicSupplierProposalSuccessActon(data));
    yield put(newSuccessNotificationAction('Proposal Added!'));
    yield put(push('/my-public-inquiries-supplier/'));
    } else {
      
    const response = yield call(api.addStagingSupplierPublicProposal, payload);
    const { data } = response;
    // yield put(addMyPublicSupplierProposalSuccessActon(data));
    yield put(newSuccessNotificationAction('Proposal Added! Pending'));
    yield put(push('/my-public-inquiries-supplier/'));
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPublicInquiryIsLoading(false));
  }
}

function* editSupplierPublicProposal({ payload }) {
  try {
    yield put(setMySupplierPublicInquiryIsLoading(true));
    const response = yield call(api.editSupplierPublicProposal, payload);
    const { data } = response;
    yield put(editMyPublicSupplierProposalSuccessAction(data));
       yield put(newSuccessNotificationAction('Proposal Edited!'));
    yield put(push('/my-public-inquiries-supplier/'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPublicInquiryIsLoading(false));
  }
}

function* deleteArtisanPublicProposal({ payload }) {
  try {
    yield put(setMySupplierPublicInquiryIsLoading(true));
    yield call(api.deleteSupplierPublicProposal, payload);
    yield put(deleteMyPublicSupplierProposalSuccessAction(payload.inquiryId));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPublicInquiryIsLoading(false));
  }
}

export default function*() {
  yield takeLatest(
    actions.GET_MY_SUPPLIER_PUBLIC_INQUIREY,
    getSupplierPublicInquiry
  );
  yield takeLatest(
    actions.GET_MY_SUPPLIER_PUBLIC_INQUIRIES,
    getMySupplierPublicInquiries
  );
  yield takeLatest(actions.ADD_PUBLIC_SUPPLIER_PROPOSAL, addSupplierPublicProposal )
  yield takeLatest(actions.EDIT_PUBLIC_SUPPLIER_PROPOSAL, editSupplierPublicProposal )
  yield takeLatest(actions.DELETE_PUBLIC_SUPPLIER_PROPOSAL, deleteArtisanPublicProposal)
  yield takeLatest(actions.GET_MY_SUPPLIER_PUBLIC_PROPOSALS, getSupplierPublicProposals)
  yield takeLatest(actions.GET_MY_ARTSAN_PUBLIC_PROPOSAL, getSupplierPublicProposal);
  yield takeLatest(actions.FILTER_MY_SUPPLIER_PUBLIC_INQUIRIES, filterMySupplierPublicInquiries)
}

// import { put, call, takeLatest } from 'redux-saga/effects';
// import * as api from './Api';
// import { actions } from './Reducer';
// import {
//   setMySupplierPublicInquiryIsLoading,
//   // getSupplierPublicInquirySuccessAction,
//   getMySupplierPublicInquirySuccessAction,
//   getMySupplierPublicInquiriesSuccessAction,
// } from './Actions';

// import {
//   errorNotificationFromError,
//   newSuccessNotificationAction,
// } from '../../../notifications/Actions';

// const body = {
//   offset: 0,
//   size: 10,
//   searchTerm: '',
//   filterBy: [{ moderated: false }], // for testing only value === true
//   sort: 'createdAt',
//   dir: 'asc',
// };

// function* getMySupplierPublicInquiries({ payload }) {
//   const defBody = {
//     ...body,
//     ...payload,
//   };
//   try {
//     yield put(setMySupplierPublicInquiryIsLoading(true));
//     const response = yield call(api.getMySupplierPublicInquiries, defBody);
//     const { data } = response;
//     const { content, count } = data;
//     console.log(content);
//     yield put(getMySupplierPublicInquiriesSuccessAction(content));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setMySupplierPublicInquiryIsLoading(false));
//   }
// }

// function* getSupplierPublicInquiry({ payload }) {
//   const inquireyId = payload;
//   const body = {
//     inquiryID: inquireyId,
//   };

//   try {
//     yield put(setMySupplierPublicInquiryIsLoading(true));
//     const response = yield call(api.getMySupplierPublicInquiry, body);
//     const { data } = response;

//     console.log(data);
//     yield put(getMySupplierPublicInquirySuccessAction(data));
//     yield put(newSuccessNotificationAction('Get Public Inquiry'));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setMySupplierPublicInquiryIsLoading(false));
//   }
// }

// export default function*() {
//   yield takeLatest(
//     actions.GET_MY_SUPPLIER_PUBLIC_INQUIREY,
//     getSupplierPublicInquiry
//   );
//   yield takeLatest(
//     actions.GET_MY_SUPPLIER_PUBLIC_INQUIRIES,
//     getMySupplierPublicInquiries
//   );
// }
